var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',{attrs:{"dense":""}},_vm._l((_vm.events[_vm.city]),function(event,i){return _c('v-col',{key:i,attrs:{"cols":"12"}},[_c('EventCard',{attrs:{"event":event,"apihost":_vm.apihost,"city":_vm.city},on:{"show_event":_vm.show_event}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }